<template>
  <div class="mb-4" style="border-bottom: 1px dashed gray;">
    <b-row class="mb-2" align-v="center">
      <b-col :cols="11">
        <b-row>
          <b-col :cols="4">
            <b-form-group label="Field">
              <b-form-select
                :value="column"
                @change="v => onChange({column: v})"
                :options="columnOptions"
                placeholder="Select field"
                :state="showErrors && !column ? false : null"
                required/>
            </b-form-group>
          </b-col>

          <template v-if="column && !isColumnCategorical">
            <b-col :cols="4" class="px-0" style="padding-left: 0; padding-right: 0;">
              <b-form-group label="Operator">
                <b-form-select
                  :value="operator"
                  @change="v => onChange({operator: v})"
                  :options="operatorOptions"
                  placeholder="Select condition"
                  :state="showErrors && !operator ? false : null"
                  required/>
              </b-form-group>
            </b-col>

            <b-col :cols="4" v-if="operator && input.component">
              <div>
                <b-form-group label="Value">
                  <div>
                    <component
                      :key="`${column}-${operator}`"
                      :is="input.component"
                      :isRange="input.isRange"
                      :value="value"
                      :value2="value2"
                      :showErrors="showErrors"
                      @change="onChange"/>
                  </div>
                </b-form-group>
              </div>
            </b-col>
          </template>
        </b-row>
      </b-col>
      <b-col :cols="1">
        <i class="fa fa-remove fa-lg text-danger" @click="$emit('delete')"/>
      </b-col>
    </b-row>
    <b-row v-if="column" class="mb-3">
      <b-col :cols="11">
        <div v-if="isColumnCategorical">
          <div class="mb-1">
            <strong>Click to select values that apply</strong>
            <b-button size="sm" variant="link" @click="toggleStatsHidden">
              {{isStatsHidden ? "Show" : "Hide"}} options
            </b-button>
          </div>
          <b-card-group deck v-if="!isStatsHidden">
            <b-card
              @click="() => handleCategoricalValueClick(count[0])"
              style="min-width: 170px; cursor: pointer;"
              class="mb-1"
              v-for="count in columnValueCounts"
              :key="count[0]"
              body-class="px-3 py-3"
              :bg-variant="listValues.includes(count[0]) ? 'primary' : 'dark'">
              <div class="text-center">
                <h4 class="mb-0 pb-0">{{count[0]}}</h4>
                <div>{{count[1] | formatInt}} Users</div>
                <div class="small">{{100 * count[1] / columnValueCountTotal | formatInt}}% of portfolio</div>
              </div>
            </b-card>
          </b-card-group>
        </div>


		<div v-else-if="isObject">
			<!-- <div>This is an object</div> -->
          <div class="mb-1">
            <strong>Preview keys in objects</strong>
            <b-button size="sm" variant="link" @click="toggleStatsHidden">
              {{isStatsHidden ? "Show" : "Hide"}} options
            </b-button>
          </div>
          <b-card-group deck v-if="!isStatsHidden">
            <b-card

              style="min-width: 170px; cursor: pointer;"
              class="mb-1"
              v-for="key_ in columnValueKeys"
              :key="key_"
              body-class="px-3 py-3"
              :bg-variant="listValues.includes(key_) ? 'primary' : 'dark'">
              <div class="text-center">
                <h4 class="mb-0 pb-0">{{key_}}</h4>

                <div class="mb-0 pb-0">{{fieldToPreview(key_)}}</div>
              </div>
            </b-card>
          </b-card-group>
        </div>

		<div v-else-if="isArray">
			<!-- <div>This is an object</div> -->
          <div class="mb-1">
            <strong>Click to preview arrays of type</strong>
            <b-button size="sm" variant="link" @click="toggleStatsHidden">
              {{isStatsHidden ? "Show" : "Hide"}} options
            </b-button>
          </div>
          <b-card-group deck v-if="!isStatsHidden">
            <b-card
              style="min-width: 170px; cursor: pointer;"
              class="mb-1"

              body-class="px-3 py-3"
              :bg-variant="listValues.includes(columnArrayOf) ? 'primary' : 'dark'">
              <div class="text-center">
                <h4 class="mb-0 pb-0">{{columnArrayOf}}</h4>

                <div class="mb-0 pb-0">{{arrayPreview}}</div>
              </div>
            </b-card>
          </b-card-group>
        </div>

        <div v-else-if="columnType === 'numeric'">
          <div
            v-if="!isStatsHidden"
            style="display: inline-block; border-radius: 5px; border: 2px solid gray;"
            class="py-2 px-1">
            <chart :options="numericChartOptions()"/>
            <div style="" class="mt-1 text-center">
              <div style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
                <small>Minimum</small>
                <h5>{{columnObject['min'] | formatMoney}}</h5>
              </div>
              <div style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
                <small>Maximum</small>
                <h5>{{columnObject['max'] | formatMoney}}</h5>
              </div>
              <div style="display: inline-block;" class="px-3 text-center">
                <small>Average</small>
                <h5>{{columnObject['mean'] | formatMoney}}</h5>
              </div>
            </div>
          </div>
          <b-button size="sm" variant="link" @click="toggleStatsHidden" style="vertical-align: top;">
            {{isStatsHidden ? "Show" : "Hide"}} Statistics Chart
          </b-button>
        </div>



        <div v-else-if="columnType === 'datetime'">
          <div
            v-if="!isStatsHidden"
            style="display: inline-block; border-radius: 5px; border: 2px solid gray;"
            class="py-2 px-1">
            <chart :options="datetimeChartOptions()"/>
            <div style="" class="mt-1 text-center">
              <div style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
                <small>Start Date</small>
                <h5>{{formatDate(columnObject['min'])}}</h5>
              </div>
              <div style="display: inline-block;" class="px-3 text-center">
                <small>End Date</small>
                <h5>{{formatDate(columnObject['max'])}}</h5>
              </div>
            </div>
          </div>
          <b-button size="sm" variant="link" @click="toggleStatsHidden" style="vertical-align: top;">
            {{isStatsHidden ? "Show" : "Hide"}} Statistics Chart
          </b-button>
        </div>

      </b-col>
    </b-row>
  </div>
</template>

<script>
	import {Chart} from 'highcharts-vue';
	import NumericInput from './NumericInput';
	import StringInput from './StringInput';
	import DatetimeInput from './DatetimeInput';
	import TimedeltaInput from './TimedeltaInput';
	import ArrayInput from './ArrayInput';
	import ObjectInput from './ObjectInput';


	import moment from 'moment';

	const _type = obj => obj ? obj.type : null;
	const dateFormat = 'Y-MM-DD hh:mm';

	export default {
		name: 'Condition',

		components: {NumericInput, StringInput, DatetimeInput, TimedeltaInput, ObjectInput,ArrayInput, Chart},

		props: {
			showErrors: Boolean,
			id: String,
			collection: String,
			database: String,
			column: String,
			operator: String,
			value: [String, Number],
			value2: [String, Number],
			listValues: Array
		},

    data() {
		const fileList = this.$store.state.files.fileList;
			return {
				files: fileList,
				isStatsHidden: false,

				// changed_data : ''

      }
    },

		created() {
			this.onChange({});
			// this.$root.$on('selected-collection', (val) => {
			// 	this.changed_data = val;
			// })

		},

		methods: {
			toggleStatsHidden() {
				this.isStatsHidden = !this.isStatsHidden;
      },

		fieldToPreview(field){
				return this.columnObject && this.columnObject['keys'] && this.columnObject['preview'] ? this.columnObject['preview'][field] : [];
			},



			onChange(changes) {
				const {column, operator, value, value2, listValues} = this;
        const data = {column, operator, value, value2, listValues, ...changes};

        if (!!value && operator.indexOf('numeric') > -1) {
          data.value = parseInt(value);
        }

        console.log("Type: ", operator, value, typeof value)

				const {isRange, component} = this.computeInputType(data.operator);
				const complete =
					data.column &&
					data.operator &&
					(!component || data.value) &&
					(!isRange || data.value2) &&
					(!this.isColumnCategorical || data.listValues.length > 0);

				this.$emit('change', {...data, complete});
			},

			formatDate(d) {
				return moment(d)
					.format(dateFormat);
			},

			handleCategoricalValueClick(value) {
				this.onChange({
					listValues: this.listValues.includes(value) ?
						this.listValues.filter(x => x !== value) :
						[...this.listValues, value]
				});
			},

			computeInputType(operator) {
				if (operator === 'in') {
					return {
						component: null,
						isRange: false
					};
				}

				const type = _type(this.columnRules.find(({key}) => key === operator));
				const isRange = type && type.endsWith('[]');

				const name = isRange && type ? type.substr(0, type.length - 2) : type;
				const component = name ? `${name}-input` : null;

				return {component, isRange};
			},

			numericChartOptions() {
				const data = this.columnObject['bins10'];

				return {
					chart: {
						width: 400,
						height: 200,
						type: 'column'
					},
					title: {
						text: null
					},
					xAxis: {
						categories: data.map(bin => Math.round((bin[0] + bin[1]) * 100 / 2) / 100),
						crosshair: true
					},
					yAxis: {
						min: 0,
						title: {
							text: null
						}
					},
					tooltip: {
						headerFormat: '',
						pointFormat: '<b>{point.y}</b>',
						footerFormat: '',
						shared: true,
						useHTML: true
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0
						}
					},
					series: [{
						showInLegend: false,
						name: this.columnObject.name,
						data: data.map(bin => bin[2])
					}]
				};
			},



			datetimeChartOptions() {
				const data = this.columnObject['bins10'];

				const avg = (a, b) => {
					a = moment(a);
					a.add(moment(b)
						.diff(a) / 2);
					return a;
				};

				return {
					chart: {
						width: 400,
						height: 200,
						type: 'bar'
					},
					title: {
						text: null
					},
					xAxis: {
						categories: data.map(bin => this.formatDate(avg(bin[0], bin[1]))),
						crosshair: true
					},
					yAxis: {
						min: 0,
						title: {
							text: null
						}
					},
					tooltip: {
						headerFormat: '',
						pointFormat: '<b>{point.y}</b>',
						footerFormat: '',
						shared: true,
						useHTML: true
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0
						}
					},
					series: [{
						showInLegend: false,
						name: this.columnObject.name,
						data: data.map(bin => bin[2])
					}]
				};
			}
		},

		computed: {
			columns() {
				console.log("Database: ", this);
				var columns = [];
				this.files.forEach(file => {
					if (file.database === this.database && file['originalName'] === this.collection) {
						columns = file.columns;
					}
				});
				//return this.$store.getters.fileColumns(this.changed_data);
				// return this.$store.getters.fileColumns(this.collection);
				return columns;
			},

			columnObject() {
				return this.columns.find(({slug}) => slug === this.column);
			},

			isColumnCategorical() {
				return this.columnObject
					&& !!this.columnObject['is_cat'] && !this.isObject && !this.isArray;
			},

			isObject(){
				// console.log(this.columnObject && this.columnObject['type'] === 'object', "isObjectValue");

				return this.columnObject && this.columnObject['type'] === 'object';
			},
			isArray(){
				// console.log(this.columnObject && this.columnObject['type'] === 'object', "isObjectValue");

				return this.columnObject && this.columnObject['type'] === 'array';
			},

			columnValueCounts() {
				return this.columnObject && this.columnObject['counts'] ? this.columnObject['counts'] : [];
			},

			columnValueKeys() {
				return this.columnObject && this.columnObject['keys'] ? this.columnObject['keys'] : [];
			},

			columnArrayOf() {
				return this.columnObject && this.columnObject['of'] ? this.columnObject['of'] : [];
			},

			arrayPreview() {
				return this.columnObject && this.columnObject['of'] ? this.columnObject['preview'] : [];
			},



			columnValueCountTotal() {
				return Math.max(1, this.columnValueCounts.reduce((a, b) => a + b[1], 0));
			},

			rules() {
				return this.$store.state.general.filters;
			},

			columnType() {
				return _type(this.columnObject);
			},

			columnRules() {
				return this.rules[this.columnType] || [];
			},

			columnOptions() {
				return this.columns
          .filter(col => !col.hasOwnProperty('keep') || col.keep)
          .map(({slug, name}) => ({value: slug, text: name}));
			},

			operatorOptions() {
				return this.columnRules.map(({key, description}) => ({
					value: key,
					text: description
				}));
			},

			input() {
				return this.computeInputType(this.operator);
			},
		},

		watch: {
			column() {
				if (this.isColumnCategorical) {
					this.onChange({
						operator: 'in',
						listValues: []
					});
					return;
				}

				if (this.operator && !this.columnRules.find(({key}) => key === this.operator)) {
					this.onChange({operator: null});
				}
			}
		}
	};
</script>
